export interface CondutorLookup {
  /**
   * O usuário do grupo a que este condutor corresponde (casado por CPF).
   * `null` no escopo COMPLETO, em que não há a quem amarrar.
   */
  idUsuarioCondutor?: number | null;
  idCondutorSgtf: string;
  cpf: string;
  nome: string;
  cnh: string;
  condutorNomeCpf: string;
}

/**
 * GET /cteos/veiculos (src/services/cteos.service.ts#buscarVeiculosPorTransportador).
 * A lista não antecipa bloqueio — quem recusa é o POST /cteos, com um dos
 * códigos `CTEOS_VEICULO_*` (respostas.ts#classificarErroVeiculo). Não há
 * como saber que um veículo está bloqueado antes de tentar.
 */
export interface VeiculoProprio {
  idVeiculo: number;
  placa: string;
  domCapacidade: number | null;
  domMarca: string | null;
  domModelo: string | null;
}

/** GET /atf/lookup/municipios (src/services/atf.service.ts). `codIbge` ausente = não mapeado no de-para do DER. */
export interface MunicipioLookup {
  nome: string;
  indice: number;
  codIbge?: string;
}

export interface Passageiro {
  nome: string;
  docIdentificacao: string;
  orgaoExpedidor: string;
}

export interface RotaResposta {
  kmIda: number;
  kmVolta: number;
  rodovias: string[];
  itinerarioSugerido: string;
  estimado: boolean;
}

export interface TarifaResposta {
  idPlano: number;
  nomePlano: string;
  valorMinimo: number;
  valorPorKm: number;
  vigenciaInicio: string;
}

export interface ElegibilidadeResposta {
  avaliadoEm: string;
  motoristas: Record<string, { bloqueado: boolean; faturasCteEmAberto: number; totalDevido: number; motivo?: string }>;
}

export interface ParametrosWizard {
  itinerarioAutomatico: boolean;
  permitirReduzirValor: boolean;
  permitirReduzirKm: boolean;
  permitirSomenteIda: boolean;
  diasRetroativosPermitidos: number;
  maxDiasAgendamento: number;
  kmFiscalIncluiVolta: boolean;
  bloquearInadimplente: boolean;
  avisarSaldoBaixoKm: number;
  fiscal?: { aliquotaICMS?: number };
}

/** O estado acumulado pelos 7 passos do wizard. */
export interface WizardState {
  idCondutorSgtf: string | null;
  idUsuarioCondutor: number | null;
  /** "CPF - NOME", o formato que o DER espera no documento. */
  condutorNomeCpf: string;
  /** Só o nome, para exibir no rail e na revisão. */
  condutorNome: string;
  idVeiculo: number | null;
  idVeiculoSgtf: string | null;
  placa: string;
  municipioOrigemIndice: number | null;
  municipioDestinoIndice: number | null;
  /** Nomes só para exibir no rail e na revisão — o que vai ao documento é o índice/IBGE. */
  municipioOrigemNome: string;
  municipioDestinoNome: string;
  cMunIni: string;
  cMunFim: string;
  dataIda: string;
  horarioIda: string;
  dataVolta: string;
  horarioVolta: string;
  somenteIda: boolean;
  kmIda: number;
  kmVolta: number;
  kmIdaBase: number;
  kmVoltaBase: number;
  itinerario: string;
  valorCentavos: number;
  tomaNome: string;
  tomaCpfCnpj: string;
  passageiros: Passageiro[];
}

export const ESTADO_INICIAL: WizardState = {
  idCondutorSgtf: null,
  idUsuarioCondutor: null,
  condutorNomeCpf: '',
  condutorNome: '',
  idVeiculo: null,
  idVeiculoSgtf: null,
  placa: '',
  municipioOrigemIndice: null,
  municipioDestinoIndice: null,
  municipioOrigemNome: '',
  municipioDestinoNome: '',
  cMunIni: '',
  cMunFim: '',
  dataIda: '',
  horarioIda: '',
  dataVolta: '',
  horarioVolta: '',
  somenteIda: false,
  kmIda: 0,
  kmVolta: 0,
  kmIdaBase: 0,
  kmVoltaBase: 0,
  itinerario: '',
  valorCentavos: 0,
  tomaNome: '',
  tomaCpfCnpj: '',
  passageiros: [],
};
